import { render, staticRenderFns } from "./Livraisonprix.vue?vue&type=template&id=4edec6e6&"
import script from "./Livraisonprix.vue?vue&type=script&lang=js&"
export * from "./Livraisonprix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports